/**
 * Recommendations Slider Logic
 * Assets/recommendations-slider.js
 */
if (typeof initRecommendationSlider !== 'function') {
  window.initRecommendationSlider = function(section) {
    const container = section.querySelector('.swiper-container');
    if (!container || container.classList.contains('swiper-initialized')) return;

    new Swiper(container, {
      direction: 'horizontal',
      slidesPerView: 1.5,
      spaceBetween: 15,
      freeMode: true,
      scrollbar: {
        el: container.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        580: { slidesPerView: 2, slidesPerGroup: 2 },
        959: { slidesPerView: 3, slidesPerGroup: 3 },
        1050: { slidesPerView: 4, slidesPerGroup: 4 }
      }
    });
    
    container.classList.add('swiper-initialized');
  };
}

// Global listener for the ProductRecommendations custom element
document.addEventListener('recommendations:loaded', function(e) {
  if (e.detail && e.detail.section) {
    window.initRecommendationSlider(e.detail.section);
  }
});